@if (!loading && passport && chart) {
  <div
    [options]="chart"
    [theme]="getChartTheme()"
    (chartInit)="onChartInit($event)"
    (chartTreeRoam)="onTreeRoam()"
    echarts
    id="hierarchyGraph.{{passport.id}}">
  </div>
}
@if (loading) {
  <div class="d-flex align-items-center justify-content-center">
    <ix-spinner></ix-spinner>
  </div>
}
